import React, { useEffect, useState } from 'react'
import { Alert, Box, Button, Card, CardContent, Dialog, FormControl, IconButton, InputLabel, MenuItem, Select, Snackbar, styled, TableCell, tableCellClasses, TextField, Typography, CircularProgress } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Switch from '@mui/material/Switch';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'axios';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'white',
        color: 'black',
        fontSize: 15,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
        padding: '6px 16px'
    },
}));


function LotteryCategories() {
    const [open, setOpen] = useState(false);
    const [checked, setChecked] = React.useState(true);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [lotteries, setLotteries] = useState([]);
    const [editLotteryId, seteditLotteryId] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');

    const [formData, setFormData] = useState({
        entity: '',
        lotteryName: '',
        status: checked ? '1' : '0',
    });

    const validate = () => {
        let tempErrors = {};
        tempErrors.entity = formData.entity ? "" : "Select the Compnay Name ";
        tempErrors.lotteryName = formData.lotteryName ? "" : "Lottery name is required.";
        setErrors(tempErrors);
        return Object.values(tempErrors).every(x => x === "");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) {
            setMessage("Please fill in all fields correctly.");
            setSeverity('error');
            setOpen(true);
            return;
        }

        try {
            if (editLotteryId) {
                const response = await axios.put(`https://servermunidasa.ccsoftwares.com/lottery/updateLotteries/${editLotteryId}`, formData, {
                });
                console.log("Update response:", formData);
                setMessage('Lottery updated successfully!');
            } else {
                const response = await axios.post('https://servermunidasa.ccsoftwares.com/lottery/addLottery', formData
                );
                setMessage('New Lottery added successfully!');
            }
            fetchLotteries();
            setSeverity('success');
            setOpen(true);

            setFormData({
                entity: '',
                lotteryName: '',
                status: 1,
            });
            seteditLotteryId(null);
            handleDialogClose();

        } catch (error) {
            console.error('Error submitting lottery data:', error.response ? error.response.data : error.message);
            setMessage('Failed, Please try again...');
            setSeverity('error');
            setOpen(true);
        }
    };

    const handleInputChange = (e) => {
        setFormData(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value
        }));
    };

    const handleSwitchChange = (event) => {
        setChecked(event.target.checked);
        setFormData({ ...formData, status: event.target.checked ? '1' : '0' });
    };

    const fetchLotteries = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://servermunidasa.ccsoftwares.com/lottery/getAllLotteries');
            const data = await response.json();
            setLotteries(data);
        } catch (error) {
            console.error('Error fetching dealers:', error);
        } finally {
            setLoading(false);
        }

    };

    const handleEditLottery = (ticket) => {
        console.log(ticket)
        setFormData({
            entity: ticket.entity,
            lotteryName: ticket.lotteryName,
            status: ticket.status,
        });
        setChecked(ticket.status === 1);
        seteditLotteryId(ticket.lotteryKey);
        setDialogOpen(true);

    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    useEffect(() => {
        fetchLotteries();
    }, []);

    const handleDeleteLottery = async (lotteryKey) => {
        try {
            await axios.delete(`https://servermunidasa.ccsoftwares.com/lottery/deleteLotteries/${lotteryKey}`);
            fetchLotteries();
            setMessage('Lottery Deleted successfully!');
            setSeverity('success');
            setOpen(true);
        } catch (error) {
            console.error('Error deleting lottery:', error);
            setMessage('Failed to delete lottery. Please try again.');
            setSeverity('error');
            setOpen(true);
        }
    };

    const handleDialogOpen = () => {
        setDialogOpen(true);
    };
    const handleDialogClose = () => {
        setDialogOpen(false);
        setFormData({
            entity: '',
            lotteryName: '',
            status: 1,
        });
        setErrors({});
        seteditLotteryId(null);
        setChecked(true);
    };
    const navigate = useNavigate();

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: 'black',
            fontWeight: 'bold',
            fontSize: '2rem',
            minHeight: '100vh',
            paddingTop: '20px',
        }}>
            <Card sx={{ width: '97%', padding: '20px', marginTop: '10px' }}>
                <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <button
                            style={{
                                backgroundColor: 'white',
                                color: 'Black',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: 30,
                                marginTop: 5,
                            }}
                            onClick={() => navigate(-1)}
                        >
                            <ArrowCircleLeftIcon fontSize='2' />
                        </button>
                        <h2 style={{ margin: 0 }}>LOTTERIES</h2>
                        <Button
                            variant="outlined"
                            sx={{ color: 'black', borderColor: 'black' }}
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={handleDialogOpen}
                        >
                            Add New Cattegory
                        </Button>
                    </Box >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', marginBottom: '20px' }}>
                        <FormControl size='small'
                            variant="outlined"
                            placeholder="Select Company Name"
                            sx={{
                                width: '30%',
                                borderRadius: '15px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                }
                            }}>
                            <InputLabel id="company-name-label">Select Company Name</InputLabel>
                            <Select labelId="company-name-label"
                                label="Select Company Name"
                                name="entity"
                                value={formData.entity}
                                onChange={(e) => setFormData({ ...formData, entity: e.target.value })}
                            >
                                <MenuItem value="">ALL</MenuItem>
                                <MenuItem value="NLB">NLB</MenuItem>
                                <MenuItem value="DLB">DLB</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            size='small'
                            variant="outlined"
                            placeholder="Search Lottery Name"
                            sx={{
                                width: '30%',
                                borderRadius: '15px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '30px',
                                }
                            }}
                            InputProps={{
                                startAdornment: (
                                    <SearchIcon sx={{ marginRight: '8px', color: 'grey' }} />
                                )
                            }}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
                        />
                    </Box>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                            <svg width={0} height={0}>
                                <defs>
                                    <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                        <stop offset="0%" stopColor="#e01cd5" />
                                        <stop offset="100%" stopColor="#1CB5E0" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
                        </Box>
                    ) : (
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <TableContainer component={Paper} sx={{ width: '90%', maxHeight: '550px' }}>
                                <Table stickyHeader sx={{ minWidth: 700, }} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell><b>COMPANY NAME</b></StyledTableCell>
                                            <StyledTableCell><b>LOTTERY NAME</b></StyledTableCell>
                                            <StyledTableCell><b>STATUS</b></StyledTableCell>
                                            <StyledTableCell><b>ACTION</b></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {lotteries
                                            .filter(lottery => {
                                                return !formData.entity || lottery.entity === formData.entity;
                                            })
                                            .filter(lottery => lottery.lotteryName.toLowerCase().includes(searchQuery))
                                            .map((lottery) => (
                                                <StyledTableRow key={lottery.lotteryKey} >
                                                    <StyledTableCell>{lottery.entity}</StyledTableCell>
                                                    <StyledTableCell>{lottery.lotteryName}</StyledTableCell>
                                                    <StyledTableCell>{lottery.status === 1 ? 'Active' : 'Inactive'}</StyledTableCell>
                                                    <StyledTableCell >
                                                        <IconButton aria-label="edit" onClick={() => handleEditLottery(lottery)}>
                                                            <EditIcon />
                                                        </IconButton>
                                                        {/* <IconButton aria-label="delete" onClick={() => handleDeleteLottery(lottery.lotteryKey)}>
                                                        <DeleteForeverIcon />
                                                    </IconButton> */}
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    )}
                </CardContent>
            </Card>




            {/* Form Dialog box */}
            <Dialog open={dialogOpen} onClose={handleDialogClose}>
                <Card sx={{ width: '400px', minHeight: 150, borderRadius: 3, justifyContent: 'center' }}>
                    <CardContent sx={{ position: 'relative' }}>
                        <IconButton
                            onClick={handleDialogClose}
                            sx={{
                                color: 'red',
                                position: 'absolute',
                                top: -5,
                                right: -5,
                                borderRadius: '50%',
                            }}
                        >
                            <HighlightOffIcon />
                        </IconButton>
                        <Typography variant="h5" component="div" sx={{ mb: 2, textAlign: 'center' }}>
                            Lottery Details
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                    <FormControl size="small" sx={{ m: 1, width: '100%' }}>
                                        <InputLabel id="company-name-label">Company Name</InputLabel>
                                        <Select
                                            labelId="company-name-label"
                                            label="Company Name"
                                            name="entity"
                                            value={formData.entity}
                                            onChange={handleInputChange}
                                            error={!!errors.entity}
                                            helperText={errors.entity}
                                            disabled={!!editLotteryId}
                                        >
                                            <MenuItem value="NLB">NLB</MenuItem>
                                            <MenuItem value="DLB">DLB</MenuItem>
                                        </Select>
                                    </FormControl>

                                    <TextField
                                        label="Lottery Name"
                                        size='small'
                                        name="lotteryName"
                                        value={formData.lotteryName}
                                        onChange={handleInputChange}
                                        error={!!errors.lotteryName}
                                        helperText={errors.lotteryName}
                                        disabled={!!editLotteryId}
                                        sx={{ m: 1, width: '100%' }}
                                    />

                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Switch
                                            checked={checked}
                                            onChange={handleSwitchChange}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                        <Typography variant="body1" sx={{ ml: 1 }}>Lottery Status</Typography>
                                    </Box>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                    <Button
                                        variant="outlined"
                                        sx={{ color: '#118AB2', borderColor: '#118AB2', marginRight: '10px' }}
                                        type="submit"
                                        startIcon={<SaveIcon />}
                                    >
                                        Save
                                    </Button>
                                </div>
                            </form>
                        </Box>
                    </CardContent>
                </Card>
            </Dialog>



            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>

        </div >
    )
}

export default LotteryCategories
